import React from "react";
import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import Reveal from "@/components/Reveal";
import Newsletter from "@/components/Newsletter";
import { BLOG_ARTICLES } from "@/data/blog";

export default function Blog() {
  return (
    <div data-testid="blog-page" className="pt-32">
      <section className="relative overflow-hidden py-12 md:py-20">
        <div className="mesh-bg">
          <div className="mesh-blob" style={{ width: 440, height: 440, background: "#F5C86B", top: -80, right: -40 }} />
        </div>
        <div className="relative z-10 mx-auto max-w-4xl px-6 text-center md:px-12">
          <Reveal>
            <p className="text-xs font-semibold uppercase tracking-[0.2em] text-[#F28C82]">Insights</p>
            <h1 className="mt-6 font-heading text-4xl font-light tracking-tighter text-[#4B2E5A] md:text-6xl">
              On AI, decisions & everyday life
            </h1>
            <p className="mx-auto mt-6 max-w-2xl text-lg text-[#4B2E5A]/70">
              Thoughts on decision intelligence, productivity, nutrition, beauty and building an operating system for daily life.
            </p>
          </Reveal>
        </div>
      </section>

      <section className="pb-16 md:pb-24">
        <div className="mx-auto max-w-6xl px-6 md:px-12">
          <div className="grid gap-6 md:grid-cols-2 md:gap-8">
            {BLOG_ARTICLES.map((post, i) => {
              const cardClass = "glass group block h-full overflow-hidden rounded-[24px] transition-transform hover:-translate-y-1";
              const inner = (
                <>
                  <div className="h-48 overflow-hidden">
                    <img src={post.image} alt={post.title} className="h-full w-full object-cover transition-transform duration-700 group-hover:scale-105" />
                  </div>
                  <div className="p-8">
                    <div className="flex items-center gap-3 text-xs">
                      <span className="rounded-full bg-[#B8E3D9]/40 px-3 py-1 font-medium text-[#4B2E5A]">{post.category}</span>
                      <span className="text-[#4B2E5A]/50">{post.date}</span>
                      <span className="text-[#4B2E5A]/50">· {post.read}</span>
                    </div>
                    <h2 className="mt-5 font-heading text-2xl font-medium leading-snug text-[#4B2E5A]">{post.title}</h2>
                    <p className="mt-3 leading-relaxed text-[#4B2E5A]/60">{post.excerpt}</p>
                    <span className="mt-6 inline-flex items-center gap-1.5 text-sm font-medium text-[#F28C82]">
                      Read more <ArrowRight className="h-4 w-4 transition-transform group-hover:translate-x-1" />
                    </span>
                  </div>
                </>
              );
              return (
                <Reveal key={post.slug} delay={i * 0.08}>
                  {post.href ? (
                    <a href={post.href} data-testid={`blog-card-${post.slug}`} className={cardClass}>{inner}</a>
                  ) : (
                    <Link to={`/blog/${post.slug}`} data-testid={`blog-card-${post.slug}`} className={cardClass}>{inner}</Link>
                  )}
                </Reveal>
              );
            })}
          </div>
        </div>
      </section>
      <Newsletter />
    </div>
  );
}
